<template>
  <div class="preview-box">
    <h3 class="float-left">
      处方预览
      <el-button @click="$emit('del')" v-if="handlerShow('删除')" type="info" size="small">删除处方</el-button>
      <el-button @click="$emit('download')" v-permission.not="'h,i,j'" type="info" size="small">下载处方</el-button>
      <el-button @click="$emit('print')" v-permission.not="'h,i,j'" type="info" size="small">打印处方</el-button>
      <el-button @click="$emit('receiptPrint')" v-permission.not="'h,i,j'" type="info" size="small">打印小票</el-button>
      <el-button @click="$emit('downloadEMR')" v-permission.not="'h,i,j'" type="info" size="small">
        下载电子病历
      </el-button>
    </h3>
    <div class="prescription-img">
      <template v-if="!isMedicalInsurance">
        <img v-if="url" :src="url" alt />
      </template>
      <div v-else class="no-img-text">
        {{ noImgShowText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'prescriptionPreview',
  props: {
    url: String,
    handlerShow: Function,
    isMedicalInsurance: {
      type: Boolean,
      default: false
    },
    noImgShowText: {
      type: String,
      default: '暂无图片'
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-box {
  h3 {
    button {
      // width: 80px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      border: 1px solid rgba(242, 242, 242, 1);
      font-size: 12px;
      color: rgba(112, 112, 112, 1);
      margin-left: 10px;
      > &:first-child {
        margin-left: 120px;
      }
    }
  }
}

.no-img-text {
  display: flex;
  font-size: 14px;
  color: #ed1d0a;
}
</style>
